import Vue from "vue";
import App2 from "./app2.vue";
import VueTypedJs from "vue-typed-js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "../src/assets/fonts/font.css";
import utils from "./utils";
import axios from "axios";
import router from "./router";
import { Loading } from "element-ui";

if (process.env.NODE_ENV === "production") {
//   // console.log("当前是生产环境");
//   console.log = function () {};
//   console.debug = function () {};
//   console.info = function () {};
//   console.warn = function () {};
//   console.error = function () {};
//   document.onkeydown = function (e) {
//     // if (e.keyCode == 123) {
//     //   // F12键的keyCode是123
//     //   return false;
//     // }
//   };
  document.oncontextmenu = function (event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  let devtoolsOpen = false;
  const threshold = 160;

//   setInterval(() => {
//     const widthDifference = window.outerWidth - window.innerWidth;
//     if (widthDifference > threshold) {
//       devtoolsOpen = true;
//       if (!window.location.href.includes("/login")) {
//         router.push({
//           name: "login",
//         });
//       }

//       //alert('开发者工具已打开！');
//     } else {
//       devtoolsOpen = false;
//     }
//   }, 1000);
} else {
  console.log("当前是开发环境");
}

const app = new Vue({
  router,
  render: (h) => h(App2),
}).$mount("#app");
Vue.use(ElementUI);
Vue.use(VueTypedJs);
Vue.use(router);
Vue.config.productionTip = false;
// 全局错误处理
Vue.config.errorHandler = function (err, vm, info) {
  console.error("Error:", err);
  if (typeof window !== "undefined" && window.Vue) {
    window.Vue.prototype.$message.error(
      "Uncaught runtime error occurred. Please check console for details."
    );
  }
};
Vue.prototype.$http = axios;
Vue.prototype.$utils = utils;
let loading = null;
axios.interceptors.request.use(
  (config) => {
    if (loading) {
      loading.close();
    }
    let options = {
      fullscreen: true,
      target: document.querySelector("#mainLoad"),
      lock: true,
      text: "数据加载中",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    };
    if (!config.closeLoading) {
      loading = Loading.service(options);
    }
    let authorization = sessionStorage.getItem("Authorization");
    if (authorization) {
      config.headers["Authorization"] = authorization;
    }
    return config;
  },
  (error) => {
    //失败后抛出错误
    window.sessionStorage.clear();
    window.location.reload();
    Promise.reject(error);
  }
);
//响应拦截 后端返回前端
axios.interceptors.response.use(
  (response) => {
    if(loading){
      loading.close();
    }
    
    // 对响应数据做点什么
    return response;
  }, //响应可以，正常返回数据
  (error) => {
    if(loading){
      loading.close();
    }
    // 对响应错误做些什么
    console.log(error, "---------");
    if (error.response) {
      console.log("error.response", error.response);
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          // store.commit(types.LOGOUT);
          console.log("error.response", error.response);
          if (error.response.data.code == -4) {
            app.$message({
              message:error.response.data.error,
              type: 'warning'
            });
            window.sessionStorage.clear();
            router.push("/");
            //  window.location.reload();
          } else if (error.response.data.code == -5) {
            app.$message({
              message:error.response.data.error,
              type: 'warning'
            });
            window.sessionStorage.clear();
            // window.location.reload();
          }
        case 406:
          if (error.response.data.code == -8) {
            console.log("error.response.data.data", error.response.data.data);
            alert(
              `${error.response.data.code_prompt},${error.response.data.error}`
            );
            window.sessionStorage.clear();
            //window.location.reload();
          } else {
            // alert(error.response.data.error);
          }
        default:
          console.log(error.response.data,'error.response.data>>>>>>')
         // alert(error.response.data.error);
          app.$message({
            message:error.response.data.error,
            type: 'warning'
          });
        
          
      }
    }

    return Promise.reject(error); // 返回接口返回的错误信息
  }
);
// //解决el-radio报错
Vue.directive("removeAriaHidden", {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach((item) => {
      item.removeAttribute("aria-hidden");
    });
  },
});

